import React, { useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ConfigurationContext } from "../../../contexts/Configuration";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ImportExportIcon from "@mui/icons-material/ImportExport";

const DesktopSortIcon = ({ benefitTypeId, direction }) => {
  const matchesMobileWidth = useMediaQuery("(max-width:1032px)");
  const { appliedConfiguration } = useContext(ConfigurationContext);

  const iconsSetting =
    appliedConfiguration?.coverageFinderSortingIconsSettings?.filter(
      (s) => s.benefitTypeId === benefitTypeId
    ) || [];


  const getIconAndAlt = (iconFunction, settings, isMobile) => {
    const match = settings.find(
      (icon) =>
        icon.iconFunction === iconFunction &&
        (isMobile ? icon.mobileIcon : icon.desktopIcon)
    );

    return {
      iconUrl: isMobile ? match?.mobileIcon : match?.desktopIcon,
      altText: isMobile ? match?.mobileAltText : match?.deskTopAltText,
    };
  };


  const iconMap = iconsSetting.length
    ? {
      asc: getIconAndAlt("Ascending", iconsSetting, matchesMobileWidth),
      desc: getIconAndAlt("Descending", iconsSetting, matchesMobileWidth),
      default: getIconAndAlt("Default", iconsSetting, matchesMobileWidth),
    }
    : null;

  const selected = iconMap?.[direction] || iconMap?.default;
  const hasValidIcon = selected?.iconUrl && selected.iconUrl.trim() !== "";

  // Render custom image icon if available
  if (hasValidIcon) {
    return (
      <img
        part="cfAscSortIcon"
        className="norstella-cf-SortIcon"
        src={selected.iconUrl}
        alt={selected.altText || direction}
      />
    );
  }

  // Fallback to default icons
  switch (direction) {
    case "asc":
      return <ArrowUpwardIcon />;
    case "desc":
      return <ArrowDownwardIcon />;
    default:
      return <ImportExportIcon />;
  }
};

export default DesktopSortIcon;
